import { StateCreator } from "zustand";
import orderServices from "../api-service/order-service";
export interface OrderSlice {
  orders: any[];
  order: any;
  ordersLoading: boolean;
  orderLoading: boolean;
  ordersErrorCode: number | null;
  fetchOrdersAction: (params: any) => Promise<any>;
  showOrderAction: (params: any) => Promise<any>;
  updateCartQuantity: (quantity: number) => void;
  cartQuantity: number;
}

export const createOrdersSlice: StateCreator<OrderSlice, []> = (set) => ({
  orders: [],
  order: {},
  ordersLoading: false,
  orderLoading: false,
  ordersErrorCode: null,
  cartQuantity: 0,
  fetchOrdersAction: async (params) => {
    set({ ordersLoading: true });
    try {
      const res = await orderServices.getOrders(params);
      set({ orders: res.data.data, ordersLoading: false });
      return res.data.data;
    } catch (error) {
      const errorStatus = (error as { status: number }).status;
      set({ ordersErrorCode: errorStatus, ordersLoading: false });
    }
  },
  showOrderAction: async (params) => {
    set({ orderLoading: true });
    try {
      // const res = await orderServices.showOrder(params);
      set({ order: params, orderLoading: false });
      return params;
    } catch (error) {
      const errorStatus = (error as { status: number }).status;
      set({ ordersErrorCode: errorStatus, ordersLoading: false });
    }
  },
  updateCartQuantity: (quantity) => {
    set({ cartQuantity: quantity });
  },
});
